import axios from 'axios';

import { handleLogin, logoutUser } from './actions';

// Triggered to verify the validity of a token retrieved from localStorage
// Handles all thrown errors
// Creates request to validate token
// If valid, updates state to login
// If invalid, logs out user
export const verifyToken = () => async (dispatch) => {
  return axios
    .get('/api/auth/verify-token')
    .then((res) => {
      if (!res.data || !res.data.success) {
        // Unexpected server response, don't immediately logout — surface for debugging
        // throw so the catch path can handle known error codes
        throw new Error('Invalid verify-token response');
      }
      // Current JWT is valid

      // Server issued new token to extend expiration
      if (res.data.token) {
        // Second argument is remember is always true if this is being called
        dispatch(handleLogin(res, true));
      }
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('verifyToken: error', err && err.response ? err.response.status : err.message);
      if (err.response) {
        if (err.response.status === 401) {
          // Server responded 401 -> token invalid/expired: perform logout
          dispatch(logoutUser());
        }
      }
    });
};
